import { ViewModel,View } from "binder"
import  { FilesListView } from "./filesList-view"
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { BooleanPropertyType, IntegerPropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { getAsNumber } from "src/uicomponents/components/utilities";


export class FilesListComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'FilesList';
        this.addProperty("IsReadOnly","data-b-comp-isreadonly",new BooleanPropertyType(this),false,false);
        this.addProperty("IsSingle","data-b-comp-issingle",new BooleanPropertyType(this),false,false);
        let prop = this.addProperty("SingleFileMaxSize","data-b-comp-singlemaxsize",new IntegerPropertyType(this),0,false);
        prop.tooltipText = "In KB";
        this.addProperty("FilesData","data-b-comp-fulldata",new StringPropertyType(this),null,false);

    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new FilesListViewModel(parent);
        return result;
    }
       
}

export class FilesListViewModel extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new FilesListView();
    }
    public getTypeId(): string {
        return "VM-D66016B0-F3B1-4A45-ABBE-987F779759C2"
    }

    public set IsReadOnly(v: boolean) { this._IsReadOnly = v; } public get IsReadOnly(): boolean { return this._IsReadOnly;} private _IsReadOnly: boolean;
    public set IsSingle(v: boolean) { this._IsSingle = v; } public get IsSingle(): boolean { return this._IsSingle;} private _IsSingle: boolean;
    public set SingleFileMaxSize(v: number) { this._SingleFileMaxSize = getAsNumber(v,true); } public get SingleFileMaxSize(): number { return this._SingleFileMaxSize;} private _SingleFileMaxSize: number;
    public set FilesData(v: any) { this._FilesData = v; } public get FilesData(): any { return this._FilesData;} private _FilesData: any;
    

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitFilesList(this,parameter);
    }
    
}
